<template>
  <div>
    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.calculationSpecifications' )" prop="calculationSpecifications">
          <Select v-model="resourceApplicationForm.calculationSpecifications" filterable
                  @on-change="selectEc2PriceByInstanceTypeName()">
            <Option :value="item" v-for="(item,index) in calculationSpecificationsList" v-bind:key="item">{{item}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>
    <Row>
      <Col span="22">
        <FormItem :label="$t( 'resourceLifecycle.cloudPlatformSpecifications' )">
          <Table :no-data-text="$t('common.noData')" :columns="columns" :data="cloudPlatformSpecificationsDate"></Table>
        </FormItem>
      </Col>
    </Row>
  </div>
</template>

<script>

  export default {
    name: 'AmazonVirtualMachine',
    props: ['amazonResourceApplicationBasicInfoForm'],
    components: {},
    data() {
      return {
        currentChoose: 0,
        modal_loadings: false,
        addloading: false,
        enableTerminationProtectionList: [{
          id: 0,
          name: this.$t('resourceLifecycle.yes')
        }, {
          id: 1,
          name: this.$t('resourceLifecycle.no')
        }],
        monitorList: [{
          id: 0,
          name: this.$t('resourceLifecycle.yes')
        }, {
          id: 1,
          name: this.$t('resourceLifecycle.no')
        }],
        calculationSpecificationsList: [],
        lifecycleResource: {},
        resourceApplicationForm: {
          cost: 0,
          name: '',
          enableTerminationProtection: 0,
          numberOfInstances: 1,
          instanceType: '',
          cpu: 0,
          ram: 0,
          keyName: '',
          monitor: 0,
          calculationSpecifications: '',
          os: '',
          mirror: '',
          subnet: '',
          vpc: '',
          automaticallyAssignPublicIP: 0,
          securityGroup: '',
          tags: [{
            key: '',
            value: ''
          }]
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t( 'resourceLifecycle.namecannotbeempty' ), trigger: 'blur'}
          ],
          enableTerminationProtection: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectEnableTerminationProtection' ), trigger: 'change', type: 'number'}
          ],
          numberOfInstances: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterthenumberofinstances' ), trigger: 'blur', type: 'number'}
          ],
          keyName: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectakeypair' ), trigger: 'change'}
          ],
          monitor: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectMonitoring' ), trigger: 'change', type: 'number'}
          ],
          calculationSpecifications: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectCalculationSpecification' ), trigger: 'change'}
          ],
          os: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselecttheoperatingsystem' ), trigger: 'change'}
          ],
          mirror: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectamirror' ), trigger: 'change'}
          ],
          subnet: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectsubnet' ), trigger: 'change'}
          ],
          vpc: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectnetwork' ), trigger: 'change'}
          ],
          automaticallyAssignPublicIP: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectAutoAssignPublicIP' ), trigger: 'change', type: 'number'}
          ],
          securityGroup: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectasecuritygroup' ), trigger: 'change'}
          ]
        },
        columns: [
          {
            title: this.$t( 'resourceLifecycle.selects' ),
            key: 'instanceType',
            width: 70,
            align: 'center',
            render: (h, params) => {
              let instanceType = params.row.instanceType;
              let cpu = params.row.cpuCoreNumber;
              let ram = params.row.ramSize;
              let flag = false;
              if (this.resourceApplicationForm.instanceType === instanceType) {
                flag = true
              } else {
                flag = false
              }
              let self = this
              return h('div', [
                h('Radio', {
                  props: {
                    value: flag
                  },
                  on: {
                    'on-change': () => {
                      self.resourceApplicationForm.instanceType = instanceType;
                      self.resourceApplicationForm.cpu = cpu;
                      self.resourceApplicationForm.ram = ram;
                      self.queryAWSInstancePrice();
                    }
                  }
                })
              ])
            }
          },
          {
            title: this.$t( 'resourceLifecycle.models' ),
            key: 'instanceType'
          },
          {
            title: this.$t( 'resourceLifecycle.numberofCPUcores' ),
            key: 'cpuCoreNumber'
          },
          {
            title: this.$t( 'resourceLifecycle.memoryGB' ),
            key: 'ramSize'
          }],
        cloudPlatformSpecificationsDate: [],
        volumeColumns: [
          {
            title: this.$t( 'resourceLifecycle.volumeType' ),
            key: 'volumeType',
            render: (h, params) => {
              let $volumeTypeList = this.volumeTypeList
              let self = this
              return h('Select', {
                  props: {
                    value: self.awsVolumeList[params.index].volumeType,
                    transfer: true
                  },
                  on: {
                    'on-change': (event) => {
                      self.awsVolumeList[params.index].volumeType = event
                      self.queryAWSInstancePrice();
                    }
                  }
                },
                $volumeTypeList.map(function (item) {
                  return [
                    h('Option', {
                      props: {
                        value: item.id
                      }
                    }, item.name)
                  ]
                }))
            }
          },
          {
            title: this.$t( 'resourceLifecycle.availabilityZones' ),
            key: 'availabilityZone',
            render: (h, params) => {
              let $availabilityZoneList = this.availabilityZoneList
              let self = this
              return h('Select', {
                  props: {
                    value: self.awsVolumeList[params.index].availabilityZone,
                    transfer: true
                  },
                  on: {
                    'on-change': (event) => {
                      self.awsVolumeList[params.index].availabilityZone = event
                    }
                  }
                },
                $availabilityZoneList.map(function (item) {
                  return [
                    h('Option', {
                      props: {
                        value: item.zoneName
                      }
                    }, item.zoneName)
                  ]
                }))
            }
          },
          {
            title: this.$t( 'resourceLifecycle.sizeGiB' ),
            key: 'size',
            render: (h, params) => {
              let self = this
              return h('InputNumber', {
                attrs: {
                  value: params.row.size,
                  "min": 40,
                  "max": 32768,
                  activeChange: false
                },
                on: {
                  'on-change': function (event) {
                    self.awsVolumeList[params.index].size = event
                    self.queryAWSInstancePrice();
                  }
                }
              })
            }
          },
          {
            title: 'IOPS',
            key: 'IOPS',
            render: (h, params) => {
              let self = this
              return h('InputNumber', {
                attrs: {
                  value: params.row.IOPS,
                  "min": 40,
                  "max": 32768,
                  activeChange: false
                },
                on: {
                  'on-change': function (event) {
                    self.awsVolumeList[params.index].IOPS = event
                    self.queryAWSInstancePrice();
                  }
                }
              })
            }
          },
          {
            title: this.$t( 'resourceLifecycle.whethertoencrypt' ),
            key: 'isEncryption',
            render: (h, params) => {
              return h('Checkbox', {
                props: {
                  value: params.row.isEncryption
                }
              })
            }
          },
          {
            title: this.$t( 'resourceLifecycle.operations' ),
            slot: 'delete'
          }],
        awsVolumeList: [],
        availabilityZoneList: [],
        volumeTypeList: []
      }
    },
    mounted: function () {
      this.showAll()
    },
    methods: {
      showAll: function () {
        this.queryLifecycleResourceById();
        //查询aws磁盘类型
        this.queryAWSVolumeType();
        //查询AWS可用区
        this.queryAWSAvailableZoneList();
        //查询AWS计算规格
        this.listCalculationSpecification();
      },
      queryLifecycleResourceById: function () {
        if(this.amazonResourceApplicationBasicInfoForm.resourceId==undefined){
          return;
        }
        this.$api.lifecycleResourceApplication.queryLifecycleResourceById({
          "id": this.amazonResourceApplicationBasicInfoForm.resourceId
        })
          .then(res => {
            this.lifecycleResource = res.data;
          })
      },
      //查询价格
      queryAWSInstancePrice: function () {
        var submitLifecycleResourceApplicationDTO = {
          "osType": this.lifecycleResource.lifecycleResourceInstanceDTO.lifecycleResourceInstanceOsDTO.osArchitecture,
          "duration": this.lifecycleResource.duration,
          "region": this.lifecycleResource.region,
          "lifecycleResourceInstanceDTO": {
            "instanceType": this.resourceApplicationForm.instanceType,
            "cpu": this.resourceApplicationForm.cpu,
            "ram": this.resourceApplicationForm.ram,
            "instanceNumber": this.lifecycleResource.lifecycleResourceInstanceDTO.instanceNumber
          }
        }
        // AWS 磁盘
        submitLifecycleResourceApplicationDTO.lifecycleResourceVolumeDTOS = []
        var awsVolumeList = this.awsVolumeList
        for (var i = 0; i < awsVolumeList.length; i++) {
          var lifecycleResourceVolumeDTO = {
            "accountId": this.resourceApplicationForm.accountId,
            "region": this.resourceApplicationForm.region,
            "awsZone": awsVolumeList[i].availabilityZone,
            "encrypted": awsVolumeList[i].isEncryption,
            "type": awsVolumeList[i].volumeType,
            "capacity": awsVolumeList[i].size,
            "iops": awsVolumeList[i].IOPS,
          }
          submitLifecycleResourceApplicationDTO.lifecycleResourceVolumeDTOS.push(lifecycleResourceVolumeDTO)
        }
        this.$api.awsPrice.queryAWSInstancePrice(submitLifecycleResourceApplicationDTO)
          .then(res => {
            this.resourceApplicationForm.cost = res.data
            this.$emit('success', this.resourceApplicationForm.cost);
          })
      },
      //查询aws磁盘类型
      queryAWSVolumeType: function () {
        this.$api.lifecycleResourceApplication.queryAWSVolumeType()
          .then(res => {
            this.volumeTypeList = res.data;
          })
      },
      //查询AWS可用区
      queryAWSAvailableZoneList: function () {
        if(this.amazonResourceApplicationBasicInfoForm.accountId==''&&this.amazonResourceApplicationBasicInfoForm.region==''){
          return;
        }
        this.$api.lifecycleResourceApplication.queryAWSAvailableZoneList({
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            this.availabilityZoneList = res.data;
          })
      },
      //查询AWS计算规格
      listCalculationSpecification: function () {
        this.$api.price.listCalculationSpecification({
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            this.calculationSpecificationsList = res.data;
            this.resourceApplicationForm.calculationSpecifications = this.amazonResourceApplicationBasicInfoForm.calculationSpecifications
            this.selectEc2PriceByInstanceTypeName();
          })
      },
      //查询AWS云平台规格
      selectEc2PriceByInstanceTypeName: function () {
        this.$api.price.selectEc2PriceByInstanceTypeName({
          "instanceSpecification": this.resourceApplicationForm.calculationSpecifications,
          "region": this.lifecycleResource.region
        })
          .then(res => {
            this.cloudPlatformSpecificationsDate = res.data;
          })
      },
      /********************磁盘********************************/
      // 添加
      addVolume: function () {
        this.awsVolumeList.push({
          volumeType: 0,
          availabilityZone: '',
          size: 100,
          IOPS: 100,
          isEncryption: false
        })
        this.queryAWSInstancePrice();
      },
      // 删除
      removeVolume(index) {
        this.awsVolumeList.splice(index, 1);
        this.queryAWSInstancePrice();
      },
      /*********************标签***********************************/
      handleAdd() {
        this.resourceApplicationForm.tags.push({
          value: '',
          key: ''
        })
      },
      handleRemoveTag(index) {
        if (this.resourceApplicationForm.tags.length === 1) {
          this.$Message.warning(this.$t( 'resourceLifecycle.atleastonesubdimensionisrequired' ))
          return
        }
        this.resourceApplicationForm.tags.splice(index, 1)
      },
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_change/aws/virtual_machine/AmazonVirtualMachine.vue